// 提交申请
const routes = [
    {
        path: "/apply",
        name: "apply_index",
        component: () => import("../views/apply/index.vue"),
        meta: { h5Header: true, h5TitleKey: "apply.title" },
        children: [
            {
                name: "add_accessory",
                path: "accessory",
                component: () => import("../views/apply/needs_accessory.vue"),
                meta: { h5TitleKey: "user.apply.accessory.title" },
            },
            {
                name: "edit_accessory",
                path: "accessory/:id",
                component: () => import("../views/apply/needs_accessory.vue"),
                meta: { h5TitleKey: "user.apply.accessory.title" },
            },
            {
                name: "add_backup",
                path: "backup",
                component: () => import("../views/apply/needs_backup.vue"),
                meta: { h5TitleKey: "user.apply.backup.title" },
            },
            {
                name: "edit_backup",
                path: "backup/:id",
                component: () => import("../views/apply/needs_backup.vue"),
                meta: { h5TitleKey: "user.apply.backup.title" },
            },
            {
                name: "add_repair",
                path: "repair",
                component: () => import("../views/apply/needs_repair.vue"),
                meta: { h5TitleKey: "apply.repairTitle" },
            },
            {
                name: "edit_repair",
                path: "repair/:id",
                component: () => import("../views/apply/needs_repair.vue"),
                meta: { h5TitleKey: "apply.repairTitle" },
            },
            {
                name: "give_back",
                path: "give_back/:id",
                component: () => import("../views/dashboard/give_back.vue"),
                meta: { h5TitleKey: "dashboard.giveBack.title" },
            },
            {
                name: "quick_repair",
                path: "quickrp",
                component: () => import("../views/apply/quick_repair.vue"),
                meta: { h5TitleKey: "user.apply.quickrp.title" },
            },
            {
                name: "edit_quickrp",
                path: "quickrp/:id",
                component: () => import("../views/apply/quick_repair.vue"),
                meta: { h5TitleKey: "user.apply.quickrp.title" },
            },
        ],
    },
];

export default routes;
